import { InjectionToken } from '@angular/core';
import { ApplicationInsights } from '@microsoft/applicationinsights-web';
import { environment } from '../../../environments/environment';
import { injectCorrelationId } from './correlation.state';

export const APP_INSIGHTS = new InjectionToken<ApplicationInsights>('APP_INSIGHTS');

export const createApplicationInsights = () => {
	const ai = new ApplicationInsights({
		config: {
			connectionString: environment.appInsightsConnectionString,
			enableAutoRouteTracking: true, // option to log all route changes,
			enableRequestHeaderTracking: true,
			enableResponseHeaderTracking: true,
			enableCorsCorrelation: true,
			disableTelemetry: environment.disableAppInsights,
		},
	});
	const correlationId = injectCorrelationId();
	ai.loadAppInsights();
	ai.context.session.id = correlationId;
	return ai;
};
